import { Navigate } from '@tanstack/react-router'
import type { ReactNode } from 'react'

import { useIsTrialAccount } from '../accountStore'

// A trial shows only the case it came for, so these pages send it to its projects.
export const HiddenOnTrial = ({ children }: { children: ReactNode }) => {
  const isTrial = useIsTrialAccount()
  if (isTrial) return <Navigate to="/projects" />
  return children
}
